import React from 'react';
import './AltMissionSection.css';

const SPARKLE_PATH = "M50 6C55 40 60 45 94 50C60 55 55 60 50 94C45 60 40 55 6 50C40 45 45 40 50 6Z";

function Sparkle({ size, opacity, style }) {
  return (
    <svg
      aria-hidden="true"
      width={size} height={size}
      viewBox="0 0 100 100"
      fill={`rgba(255,255,255,${opacity})`}
      style={style}
    >
      <path d={SPARKLE_PATH} />
    </svg>
  );
}

function ProofPill({ text }) {
  return (
    <span className="ams-proof-pill">
      <span className="ams-proof-dot" />
      {text}
    </span>
  );
}

export default function AltMissionSection() {
  return (
    <section className="ams-section">
      {/* noise texture */}
      <div aria-hidden="true" className="ams-noise" />

      {/* grid lines */}
      <div aria-hidden="true" className="ams-grid" />

      {/* floating sparkles */}
      <Sparkle size={40} opacity={0.5}  style={{ position: 'absolute', top: 60,  right: 80,  animationName: 'ams-float', animationDuration: '4s',   animationIterationCount: 'infinite', animationTimingFunction: 'ease-in-out' }} />
      <Sparkle size={20} opacity={0.3}  style={{ position: 'absolute', top: 100, right: 136, animationName: 'ams-float', animationDuration: '4s',   animationDelay: '0.8s', animationIterationCount: 'infinite', animationTimingFunction: 'ease-in-out' }} />
      <Sparkle size={28} opacity={0.22} style={{ position: 'absolute', bottom: 80, left: 80,  animationName: 'ams-float', animationDuration: '5s',   animationDelay: '0.4s', animationIterationCount: 'infinite', animationTimingFunction: 'ease-in-out' }} />

      {/* content */}
      <div className="ams-content">
        {/* eyebrow */}
        <div className="ams-eyebrow">
          <span className="ams-eyebrow-line" />
          Our Mission
          <span className="ams-eyebrow-line" />
        </div>

        {/* headline */}
        <h2 className="ams-headline">
          Your content.<br />
          Your AI.<br />
          <span className="ams-headline-dim">Your rules.</span>
        </h2>

        {/* body */}
        <p className="ams-body">
          Premsi was built so creators keep what they earn. Our AI works for you around the
          clock — engaging fans, recommending content, closing sales. You keep{' '}
          <strong className="ams-strong">90% of every sale</strong>. No hidden fees. No lock-in.
        </p>

        {/* CTAs */}
        <div className="ams-ctas">
          <a href="/invitation" className="ams-cta-primary">Start for free</a>
          <a href="#features" className="ams-cta-secondary">
            See how AI works <span>→</span>
          </a>
        </div>

        {/* proof strip */}
        <div className="ams-proof-strip">
          {[
            'AI replies to fans 24/7',
            '90% revenue kept',
            '$0 to get started',
            'No algorithm gatekeeping',
          ].map((t) => <ProofPill key={t} text={t} />)}
        </div>
      </div>
    </section>
  );
}
